import { MutableRefObject } from 'react';

/* eslint-disable @typescript-eslint/no-explicit-any */

export default (refs: (((value: any) => void) | MutableRefObject<any>)[]) => {
  return (value: any) => {
    for (const ref of refs) {
      if (typeof ref === 'function') {
        ref(value);
      } else {
        ref.current = value;
      }
    }
  };
};
